export default () => {
  function initialize() {
    var map = new google.maps.Map(document.getElementById("map-contacts"), {
      zoom: 5,
      center: new google.maps.LatLng(markersData[0][0], markersData[0][1]),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scaleControl: true,
      navigationControl: true,
      mapTypeControl: false,
      draggable: true,
      streetViewControl: false,
      zoomControl: false,
      fullscreenControl: false,
      styles: [{ stylers: [{ saturation: -100 }] }]
    });

    var marker, i;
    const markerIco = {};
    markerIco.url = "/wp-content/themes/kusum/assets/images/marker.png";
    markerIco.scaledSize = new google.maps.Size(38, 52);
    const bounds = new google.maps.LatLngBounds();

    for (i = 0; i < markersData.length; i++) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(markersData[i][0], markersData[i][1]),
        map: map,
        icon: markerIco
      });
      // let img = markersData[i][2]
      // let address = markersData[i][3]
      // marker.content = `<div class="infowindow"><div class="infowindow__img"><img src="${img}" width="231" height="108" alt="."></div><div class="infowindow__text">${address}</div></div>`;
      // var infowindow = new google.maps.InfoWindow()
      // google.maps.event.addListener(marker, 'click', (function (marker, i) {
      //   return function () {
      //     infowindow.setContent(marker.content);
      //     infowindow.open(map, marker);
      //   }
      // })(marker, i));


      bounds.extend(marker.position);
    }
    

    map.fitBounds(bounds);
    map.panToBounds(bounds);
    
    $(".on-map").on('click', function() {
      var coords = $(this).attr('coordinates').split(",");
      var latlng = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]));
      map.panTo(latlng);
      map.setZoom(10);
    });
  }
  if ($("#map-contacts").length) {
    initialize();
  }
};



// WEBPACK FOOTER //
// app/scripts/components/map-contacts.js